
function hashString(s) {
  var h = s.split("").reduce(function(a,b){a=((a<<5)-a)+b.charCodeAt(0);return a&a},0)
  return h < 0 ? -h : h
}

function debounce (delayMs, fn) {
  var timeoutID = null
  return function () {
    clearTimeout(timeoutID)
    var args = arguments
    var that = this
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delayMs)
  }
}

function partialDateToString(date, show)
{
  const DATE_SUFFIX = ['th', 'st', 'nd', 'rd']
  const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  var str = ''
  var day = date.getDate()
  if (show.day) str += ' ' + day + ((day<10 || day >12) && (day%10)<=3 ? DATE_SUFFIX[day%10] : 'th')
  if (show.month) str += ' ' + MONTHS[date.getMonth()]
  if (show.year) str += ' ' + date.getFullYear()
  return str
}
  

export {
  hashString,
  debounce,
  partialDateToString,
}



// WEBPACK FOOTER //
// ./src/util.js